import React from 'react';

const GroupComponent = ({ item }) => (
    <span>
        <strong>{item.group}</strong>
    </span>
);

export default GroupComponent;
